import PropTypes from "prop-types"
import React from "react"

import CruiseStopItem from "./CruiseStopItem"

const CruisePlanTable = ({ stops, cruisePlanId, handleMoveStop }) => {
  const renderStop = () => {
    let previousStop = null
    const stopItems = []
    stops.forEach((stop, index) => {
      stopItems.push(
        <CruiseStopItem
          key={stop.id}
          stop={stop}
          previousStop={previousStop}
          cruisePlanId={cruisePlanId}
          handleMoveStop={handleMoveStop}
          index={index}
        />
      )
      previousStop = stop
    })
    return stopItems
  }

  return (
    <div className="table-responsive overflow-y-visible">
      <table className="table-bordered table-hover mb-40 table">
        <thead>
          <tr>
            <th className="bg-gray-100 px-4"></th>
            <th className="bg-gray-100 px-4">Stop Name</th>
            <th className="bg-gray-100 px-4">Latitude</th>
            <th className="bg-gray-100 px-4">Longitude</th>
            <th className="bg-gray-100 px-4">Date of arrival</th>
            <th className="bg-gray-100 px-4">Date of departure</th>
            <th className="bg-gray-100 px-4">Time of arrival</th>
            <th className="bg-gray-100 px-4">Time of departure</th>
            <th className="bg-gray-100 px-4">Distance (nm)</th>
            <th className="bg-gray-100 px-4">Avg Cruising Speed (kn)</th>
            <th className="bg-gray-100 px-4">Duration</th>
            <th className="bg-gray-100 px-4">Status</th>
            <th className="bg-gray-100 px-4">Price</th>
            <th className="bg-gray-100 px-4">Notes</th>
            <th className="bg-gray-100 px-4">Actions</th>
          </tr>
        </thead>
        <tbody>{renderStop()}</tbody>
      </table>
    </div>
  )
}

CruisePlanTable.propTypes = {
  stops: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
  cruisePlanId: PropTypes.string.isRequired,
  handleMoveStop: PropTypes.func.isRequired,
}

export default CruisePlanTable
